import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { qrColorSchemeList } from '../../../../contentFormSections'
import { isDemoModeAtom } from '../../../../generatorState'

export const VCARD_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: qrColorSchemeList[4].primary,
	clone1: '#FFBE6A',
})

export const vCardPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? VCARD_DEMO_PRIMARY_COLOR : get(primaryColorAtom),
)

export const vCardSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? 'black' : get(secondaryColorAtom),
)

export const vCardIsUnlockedAtom = atom(false)
